import * as React from 'react';
import { ContentFilterView, ContentFilterViewProps } from './ContentFilter.view';
import { UseFormReturn } from 'react-hook-form';
import { useContext, useEffect } from 'react';
import { TreeMenuContext } from '../TreeMenu/TreeMenuProvider';

export type ContentFilterControllerProps = {
  useFormInstance: UseFormReturn;
};

export const ContentFilterController = (props: ContentFilterControllerProps) => {
  const controllerProps: ContentFilterViewProps = {
    ...props
  };

  const platformWatch = props.useFormInstance.watch('platform');

  const { setSelectedMenuItem } = useContext(TreeMenuContext);

  // When platform value is changed, we remove any selectedMenuItem that has been set
  useEffect(() => {
    setSelectedMenuItem(undefined);
  }, [setSelectedMenuItem, platformWatch]);

  return <ContentFilterView {...controllerProps} />;
};
